import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from 'src/app/services/auth/auth-service.service';
import { RestfulApiService } from '../../../../services/restful/restful-api.service';
import { ToastNotificationService } from 'src/app/services/notification/toast-notification.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
  selector: 'app-list-of-social-practices-of-language',
  templateUrl: './list-of-social-practices-of-language.component.html',
  styleUrls: ['./list-of-social-practices-of-language.component.css']
})
export class ListOfSocialPracticesOfLanguageComponent implements OnInit {

  public id = '';
  private id2 = '';
  private position = 0;
  public nameOfPSL = '';
  public nameOfPSL2 = '';
  private nameOfPSL3 = '';
  public nameOfExpectedLearning = '';
  public nameOfExpectedLearning2 = '';
  private nameOfExpectedLearning3 = '';
  private listOfPsl = [];
  public listOfPsl2 = [];
  private subjects = [];
  public subjects2 = [];
  public filteredSubjetcs = [];
  public sections = [];
  public seccionSeleccionada4 = '';
  public seccionSeleccionada6 = '';
  public materiaSeleccionada4 = '';
  public materiaSeleccionada5 = '';
  public permisoAgregar = false;
  public permisoEditar = false;
  public permisoEliminar = false;
  private token = '';
  opciones: NgbModalOptions;
  resultado: string;
  
  constructor(private modal: NgbModal, private notify: ToastNotificationService, private api: RestfulApiService, private auth: AuthServiceService, private router: Router) {
    this.opciones = {
      backdrop: 'static',
      backdropClass: 'customBackdrop'
    };
  }

  ngOnInit() {
    this.token = this.auth.obtenertoken();
    const helper = new JwtHelperService();
    const tokenEspirado = helper.isTokenExpired(this.token);
    const info = helper.decodeToken(this.token);

    if(!tokenEspirado && this.token !== null){
      this.permisoAgregar = info.permisos[0].agregar_psls;
      this.permisoEditar = info.permisos[0].actualizar_psls;
      this.permisoEliminar = info.permisos[0].eliminar_psls;
      if(info.permisos[0].visualizar_psls === true){
        let listado3;
        this.api.obtenerListadoSecciones(this.token).subscribe(respuesta => {
          listado3 = JSON.parse(JSON.stringify(respuesta)).secciones;
        }, (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            //console.log('Client-side error occured.');
          } else {
            //console.log('Server-side error occured.');
          }
          if (err.status === 400) {
            this.notify.showError("Error 400", "Secciones");
          }
          if (err.status === 401 || err.status === 404) {
            this.auth.eliminarToken();
            this.router.navigate(['', 'auth']);
          }
          if (err.status === 500) {
            this.notify.showError("Error 500", "Secciones");
          }
        }, () => {
          this.sections = listado3;
        });
        let listado2;
        this.api.obtenerListadoMaterias(this.token).subscribe(respuesta => {
          listado2 = JSON.parse(JSON.stringify(respuesta)).materias;
        }, (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            //console.log('Client-side error occured.');
          } else {
            //console.log('Server-side error occured.');
          }
          if (err.status === 400) {
            this.notify.showError("Error 400", "Secciones");
          }
          if (err.status === 401 || err.status === 404) {
            this.auth.eliminarToken();
            this.router.navigate(['', 'auth']);
          }
          if (err.status === 500) {
            this.notify.showError("Error 500", "Secciones");
          }
        }, () => {
          this.subjects = listado2;
        });
        let listado;
        this.api.obtenerListadoPSL(this.token).subscribe(respuesta => {
          listado = JSON.parse(JSON.stringify(respuesta)).psl;
        }, (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            //console.log('Client-side error occured.');
          } else {
            //console.log('Server-side error occured.');
          }
          if (err.status === 400) {
            this.notify.showError("Error 400", "PSL");
          }
          if (err.status === 401 || err.status === 404) {
            this.auth.eliminarToken();
            this.router.navigate(['', 'auth']);
          }
          if (err.status === 500) {
            this.notify.showError("Error 500", "PSL");
          }
        }, () => {
          this.listOfPsl = listado;
          this.listOfPsl2 = listado;
          this.notify.showInfo("Información actualizada", "PSL");
        });
      } else if(info.permisos[0].agregar_psls !== true){
        this.router.navigate(['', 'auth']);
      }
    } else {
      this.router.navigate(['', 'auth']);
    }
  }

  ngDoCheck(){
    for(let k = 0; k < this.listOfPsl.length; k++){
      for(let i = 0; i < this.subjects.length; i++){
        if(this.subjects[i].id === this.listOfPsl[k].materia){
          this.listOfPsl[k].tituloMateria = this.subjects[i].titulo;
        }
      }
    }
    this.listOfPsl.sort(function(a, b){
      if(a.tituloMateria < b.tituloMateria) { return -1; }
    });
  }

  open(content) {
    this.modal.open(content, this.opciones).result.then((result) => {
      this.resultado = `Closed with: ${result}`;
    }, (reason) => {
      this.resultado = `Dismissed ${this.getReasons(reason)}`;
      // console.log(`Dismissed: ${reason}`);
    });
  }

  private getReasons(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'CLOSE';
    } else {
      return  `${reason}`;
    }
  }

  listenNameOfPSL(name){
    this.nameOfPSL = name.target.value;
    this.nameOfPSL2 = name.target.value;
  }

  listenExpectedLearningOfPSL(name){
    this.nameOfExpectedLearning = name.target.value;
    this.nameOfExpectedLearning2 = name.target.value;
  }

  listenIdOfPsl(id){
    this.id2 = id.target.value;
  }

  seleccionarNivel(){
    this.materiaSeleccionada5 = '';
    if(this.seccionSeleccionada6 !== ''){
      // this.listOfPsl2 = this.filtrarPslPorMateria(this.materiaSeleccionada5);
      this.subjects2 = this.filtrarMateriasPorNivel(this.seccionSeleccionada6);
      this.subjects2.sort(function(a, b){
        if(a.titulo < b.titulo) { return -1; }
      });
      this.listOfPsl2 = [];
      this.notify.showWarning('Selecciona una materia para visualizar sus psl', 'PSL');
    } else {
      this.subjects2 = [];
      this.listOfPsl2 = this.listOfPsl;
    }
  }

  seleccionarMateria(){
    if(this.materiaSeleccionada5 !== ''){
      this.listOfPsl2 = this.filtrarPslPorMateria(this.materiaSeleccionada5);
    } else {
      this.listOfPsl2 = [];
      this.notify.showWarning('Selecciona una materia para visualizar sus psl', 'PSL');
    }
  }

  filtrarMaterias(key: string ) {
    return this.subjects.filter(object => {
      return (object.seccion === key && object.tiene_ambito === true);
    });
  }

  filtrarMateriasPorId(key: string ) {
    return this.subjects.filter(object => {
      return object.id === key;
    });
  }

  seleccionarNivelAcademico(){
    if(this.seccionSeleccionada4 !== ''){
      this.filteredSubjetcs = this.filtrarMaterias(this.seccionSeleccionada4);
      this.filteredSubjetcs.sort(function(a, b){
        if(a.titulo < b.titulo) { return -1; }
      });
    } else {
      this.filteredSubjetcs = [];
    }
  }

  filtrarMateriasPorNivel(key: string ) {
    return this.subjects.filter(object => {
      return (object.seccion === key);
    });
  }

  filtrarPslPorMateria(key: string ) {
    return this.listOfPsl.filter(object => {
      return (object.materia === key);
    });
  }


  agregarPSL(){
    if(this.nameOfPSL.trim() !== '' && this.nameOfExpectedLearning.trim() !== ''){
      if(this.materiaSeleccionada4 !== ''){
        let idRespuesta;
        this.api.agregarUnaPSL(this.token, this.nameOfPSL.trim(), this.nameOfExpectedLearning.trim(), this.materiaSeleccionada4).subscribe(respuesta => {
          idRespuesta = JSON.parse(JSON.stringify(respuesta)).id;
        }, (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            //console.log('Client-side error occured.');
          } else {
            //console.log('Server-side error occured.');
          }
          if (err.status === 400) {
            this.notify.showError('Error 400', "PSL");
          }
          if (err.status === 401 || err.status === 404) {
            this.auth.eliminarToken();
            this.router.navigate(['', 'auth']);
          }
          if (err.status === 403) {
            this.notify.showWarning('El aprendizaje ya existe en otro psl. Prueba con otro diferente', "PSL");
          }
          if (err.status === 500) {
            this.notify.showError('Error 500', "PSL");
          }
        }, () => {
          this.notify.showInfo('Se agregó la psl correctamente', "PSL");
          this.listOfPsl.push({
            id: idRespuesta,
            materia: this.materiaSeleccionada4,
            titulo: this.nameOfPSL.trim(),
            tituloMateria: this.filtrarMateriasPorId(this.materiaSeleccionada4)[0].titulo,
            aprendizaje: this.nameOfExpectedLearning.trim(),
            utilizado: 0
          });
        });
      } else {
        this.notify.showWarning('Debes seleccionar una materia para la PSL', "PSL");
      }
    } else {
      if(this.nameOfPSL.trim() === ''){
        this.notify.showWarning('No puedes agregar una psl sin nombre', "PSL");
      }
      if(this.nameOfExpectedLearning.trim() === ''){
        this.notify.showWarning('No puedes agregar una psl sin aprendizaje esperado', "PSL");
      }
    }
  }

  actualizarPSL(){
    if(this.nameOfExpectedLearning2.trim() !== this.nameOfExpectedLearning3.trim()) {
      this.peticionActualizar();
    } else {
      this.notify.showWarning('El aprendizaje no puede ser el mismo', "PSL");
    }
  }

  peticionActualizar(){
    if(this.nameOfPSL2.trim() !== '' && this.nameOfExpectedLearning2.trim() !== ''){
      let estadoRespuesta;
      this.api.actualizarUnaPSL(this.token, this.id, this.nameOfPSL2.trim(), this.nameOfExpectedLearning2.trim()).subscribe(respuesta => {
        estadoRespuesta = JSON.parse(JSON.stringify(respuesta)).estado;
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          //console.log('Client-side error occured.');
        } else {
          //console.log('Server-side error occured.');
        }
        if (err.status === 400) {
          this.notify.showError('Error 400', "PSL");
        }
        if (err.status === 401 || err.status === 404) {
          this.auth.eliminarToken();
          this.router.navigate(['', 'auth']);
        }
        if (err.status === 403) {
          this.notify.showWarning('El aprendizaje ya existe en otro psl. Prueba con otro diferente', "PSL");
        }
        if (err.status === 500) {
          this.notify.showError('Error 500', "PSL");
        }
      }, () => {
        if(estadoRespuesta === 200){
          this.notify.showInfo('Se actualizó la psl', "PSL");
          this.listOfPsl[this.position].titulo = this.nameOfPSL2.trim();
          this.listOfPsl[this.position].aprendizaje = this.nameOfExpectedLearning2.trim();
        } else {
          this.notify.showError('Ocurrió un error al procesar la solicitud', "PSL");
        }
      });
    } else {
      if(this.nameOfPSL2.trim() === ''){
        this.notify.showWarning('No puedes actualizar una psl sin nombre', "PSL");
      }
      if(this.nameOfExpectedLearning2.trim() === ''){
        this.notify.showWarning('No puedes actualizar una psl sin aprendizaje esperado', "PSL");
      }
    }
  }

  eliminarPSL(){
    if(this.id2.trim() === this.id.trim()){
      let estadoRespuesta;
      this.api.eliminarUnaPSL(this.token, this.id).subscribe(respuesta => {
        estadoRespuesta = JSON.parse(JSON.stringify(respuesta)).estado;
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          //console.log('Client-side error occured.');
        } else {
          //console.log('Server-side error occured.');
        }
        if (err.status === 400) {
          this.notify.showError('Error 400', "PSL");
        }
        if (err.status === 401) {
          this.auth.eliminarToken();
          this.router.navigate(['', 'auth']);
        }
        if (err.status === 404) {
          this.notify.showWarning('La psl que intentas eliminar no existe', "PSL");
        }
        if (err.status === 500) {
          this.notify.showError('Error 500', "PSL");
        }
      }, () => {
        if(estadoRespuesta === 200){
          this.listOfPsl.splice(this.position, 1);
          this.notify.showInfo('Se eliminó correctamente la psl', "PSL");
        } else {
          this.notify.showError('Ocurrió un error al procesar la solicitud', "PSL");
        }
      });
    } else {
      this.notify.showWarning('Verifica que el ID esté bien escrito', "PSL");
    }
  }

  mostrarPSL(idPSL, nombrePSL, aprendizajePSL, posicionPSL){
    this.id = idPSL;
    this.nameOfPSL2 = nombrePSL;
    this.nameOfPSL3 = nombrePSL;
    this.nameOfExpectedLearning2 = aprendizajePSL;
    this.nameOfExpectedLearning3 = aprendizajePSL;
    this.position = posicionPSL;
  }

}
